/**
 * OrbDocTutorialsBeginnerTaskManagerENDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsBeginnerTaskManagerENDocScreen
 */

import { useOrbDocTutorialsBeginnerTaskManagerENDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsBeginnerTaskManagerENDocScreenLogic';
import type { OrbDocTutorialsBeginnerTaskManagerENDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsBeginnerTaskManagerENDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsBeginnerTaskManagerENDocView as OrbDocTutorialsBeginnerTaskManagerENDocViewEntity } from '@app/shared';
import { OrbDocTutorialsBeginnerTaskManagerENDocBodyView } from '@/components/traits/OrbDocTutorialsBeginnerTaskManagerENDocBodyView';
import { OrbDocTutorialsBeginnerTaskManagerENDocFooterView } from '@/components/traits/OrbDocTutorialsBeginnerTaskManagerENDocFooterView';
import { OrbDocTutorialsBeginnerTaskManagerENDocHeaderView } from '@/components/traits/OrbDocTutorialsBeginnerTaskManagerENDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsBeginnerTaskManagerENDocScreenViewProps {
  config?: Partial<OrbDocTutorialsBeginnerTaskManagerENDocScreenConfig>;
}

export function OrbDocTutorialsBeginnerTaskManagerENDocScreenView({ config: propsConfig }: OrbDocTutorialsBeginnerTaskManagerENDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsBeginnerTaskManagerENDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsBeginnerTaskManagerENDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsBeginnerTaskManagerEN" trait="OrbDocTutorialsBeginnerTaskManagerENDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsBeginnerTaskManagerENDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsBeginnerTaskManagerENDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsBeginnerTaskManagerENDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsBeginnerTaskManagerENDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsBeginnerTaskManagerENDocScreenView;
